module.exports = __webpack_public_path__ + "img/Element5_Fehler_Ziffernrechnen.24748f55.png";